import React,{PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Redirect} from 'react-router-dom';
import propTypes from 'prop-types';

export default class RedirectIfUnauthentic extends Component{
  render(){
    if(this.props.isAuthentic||this.props.isAuthentic.isLoading)
      return null;
    return(
      <Redirect to={{
        pathname:this.props.loginPath,
        state:  {
          next: `${this.props.from.pathname}${this.props.from.search}`
        }
      }}/>
    )
  }
}

RedirectIfUnauthentic.propTypes={
  loginPath:propTypes.string,
  from:propTypes.shape({
    pathname: propTypes.string,
    search: propTypes.string
  }),
  isAuthentic:propTypes.bool,
  isLoading:propTypes.bool,
}
RedirectIfUnauthentic.defaultProps={
  loginPath:'/login',
  from:{ pathname:'/' }
}